import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import TrustIndexReviews from "./sections/TrustIndexReviews";
import UeberUns from "./sections/UeberUns";
import Leistungen from "./sections/Leistungen";
import Galerie from "./sections/Galerie";
import ContactBooking from "./sections/ContactBooking";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <TrustIndexReviews />
      <UeberUns />
      <Leistungen />
      <Galerie />
      <ContactBooking />
      <Footer />
    </div>;
}